import { useState } from "react";
import Chat from "@/pages/Chat";
import WhatsAppInbox from "@/pages/WhatsAppInbox";
import { MessageCircle, Send } from "lucide-react";

export default function ChatHub({ compact = false }) {
  const [tab, setTab] = useState("team");
  const wrap = compact ? "p-2" : "p-4";
  return (
    <div className={wrap} data-testid="chathub-page">
      <div className="max-w-6xl mx-auto">
        <div className="inline-flex bg-white border border-slate-200 rounded-md p-0.5 mb-3">
          <button
            type="button"
            onClick={() => setTab("team")}
            className={
              "px-3 h-8 rounded flex items-center gap-1.5 text-sm " +
              (tab === "team"
                ? "bg-slate-900 text-white"
                : "text-slate-600 hover:text-slate-900")
            }
            data-testid="chathub-tab-team"
          >
            <MessageCircle className="w-4 h-4" />
            Team Chat
          </button>
          <button
            type="button"
            onClick={() => setTab("wa")}
            className={
              "px-3 h-8 rounded flex items-center gap-1.5 text-sm " +
              (tab === "wa"
                ? "bg-[#075E54] text-white"
                : "text-slate-600 hover:text-slate-900")
            }
            data-testid="chathub-tab-wa"
          >
            <Send className="w-4 h-4" />
            WhatsApp
          </button>
        </div>
        {tab === "team" ? <Chat compact={compact} /> : <WhatsAppInbox />}
      </div>
    </div>
  );
}
